import store from '@/store'

const ALLOW_CREATE_NEW_PROVIDER = process.env.VUE_APP_ALLOW_CREATE_NEW_PROVIDER === 'true'

export default (to, from, next) => ({
    allow: ALLOW_CREATE_NEW_PROVIDER,
    redirect: { name: 'providers' }
})